"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var _listSecteurActMultiple = _interopRequireDefault(require("@/components/listSecteurActMultiple"));

var _listClientMultiple = _interopRequireDefault(require("@/components/listClientMultiple"));

var _listEnseigneMultiple = _interopRequireDefault(require("@/components/listEnseigneMultiple"));

var _listSecteurGeoMultiple = _interopRequireDefault(require("@/components/listSecteurGeoMultiple"));

var _listCascaderUtilisateur = _interopRequireDefault(require("@/components/listCascaderUtilisateur"));

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var apiAffaireCalculs = _interopRequireWildcard(require("@/api/affairecalculs"));

var _moment = _interopRequireDefault(require("moment"));

var _vue = _interopRequireDefault(require("vue"));

var _utils = require("@/helpers/utils");

var _exportModuleMixin = _interopRequireDefault(require("@/mixins/exportModuleMixin"));

var _exportListMixin = _interopRequireDefault(require("@/mixins/exportListMixin"));

var Excel = _interopRequireWildcard(require("exceljs"));

var _fileSaver = require("file-saver");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'Rapport-Synthese',
  mixins: [_exportModuleMixin.default, _exportListMixin.default],
  components: {
    listSecteurActMultiple: _listSecteurActMultiple.default,
    listClientMultiple: _listClientMultiple.default,
    listEnseigneMultiple: _listEnseigneMultiple.default,
    listSecteurGeoMultiple: _listSecteurGeoMultiple.default,
    listCascaderUtilisateur: _listCascaderUtilisateur.default
  },
  data: function data() {
    var _this = this;

    var validDate = function validDate(rule, value, callback) {
      var d = _this.currentDate || '';

      if (d === '') {
        callback(new Error('Champ obligatoire'));
      }

      if (d !== '' && !(0, _moment.default)(d, 'YYYYMM').isValid()) {
        callback(new Error('Date invalide'));
      }

      callback();
    };

    return {
      showError: false,
      refresh: 0,
      refreshEnseigne: 0,
      formData: {},
      rptData: [],
      // ---
      rules: {
        currentDate: {
          required: true,
          validator: validDate
        }
      },
      // ---
      options: [{
        label: 'Tout',
        value: 'tout'
      }, {
        label: 'En cours - Gestion mensuelle',
        value: 'gestion_mensuelle'
      }, {
        label: 'En cours - Vente initiale',
        value: 'vente_initiale'
      }, {
        label: 'En sommeil',
        value: 'sommeil'
      }, {
        label: 'Archivé',
        value: 'archive'
      }],
      // ---
      secteursact: [],
      clients: [],
      enseignes: [],
      secteursgeo: [],
      conducteur: null,
      classement: [],
      currentDate: null,
      show: false,
      percentageColumns: {
        pcMB_Etude: {
          numerator: 'mtMB_Etude',
          denominator: 'mtCAinitialHT'
        },
        pcMB_Exe: {
          numerator: 'mtMB_Exe',
          denominator: 'mtCaFdcHT'
        },
        pcMB_ConsommeNmoins1: {
          numerator: 'mtMB_ConsommeNmoins1',
          denominator: 'mtPM_ConsommeNmoins1'
        },
        pcMB_M: {
          numerator: 'mtMB_M',
          denominator: 'mtPM_M'
        },
        pcMB_CumulN: {
          numerator: 'mtMB_CumulN',
          denominator: 'mtPM_CumulN'
        },
        pcMB_CumuleTotal: {
          numerator: 'mtMB_CumuleTotal',
          denominator: 'mtPM_CumuleTotal'
        },
        pcSoldeAProduire_MB: {
          numerator: 'mtSoldeAProduire_MB',
          denominator: 'mtSoldeAProduire_PM'
        }
      }
    };
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.mixinEvents = {
      export: "RAPPORT_SYNTHESE_EXPORT",
      exported: "RAPPORT_SYNTHESE_EXPORTED"
    };
    apiAffaireCalculs.getLastGestMens(this.user.id_societe).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(result) {
        var savedData;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.loadFormData("".concat(_this2.user.id_societe, "-").concat(_this2.$route.name));

              case 2:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 5;
                  break;
                }

                _context.t0 = {};

              case 5:
                savedData = _context.t0;

                if (savedData) {
                  _this2.secteursact = savedData.secteursact || [];
                  _this2.clients = savedData.clients || [];
                  _this2.enseignes = savedData.enseignes || [];
                  _this2.secteursgeo = savedData.secteursgeo || [];
                  _this2.conducteur = savedData.conducteur || null;
                  _this2.classement = savedData.classement || [];
                  _this2.currentDate = savedData.date || null;
                } // --------------------------------------------


                if (!_this2.currentDate) {
                  if (result && result.length > 0) {
                    _this2.currentDate = (0, _moment.default)(result[0].anneemois, 'YYYYMM').subtract(1, 'months').format('YYYYMM');
                  } else {
                    _this2.currentDate = (0, _moment.default)().format('YYYYMM');
                  }
                }

                _this2.validateForm();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user'])),
  methods: _objectSpread({}, (0, _vuex.mapActions)('selections', ['updateFormData', 'loadFormData', 'resetFormData']), {
    resetForm: function () {
      var _resetForm = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.resetFormData("".concat(this.user.id_societe, "-").concat(this.$route.name));

              case 2:
                this.$refs['ElForm'].resetFields();
                this.rptData = [];
                this.secteursact = [];
                this.clients = [];
                this.enseignes = [];
                this.secteursgeo = [];
                this.conducteur = null;
                this.classement = [];
                this.currentDate = (0, _moment.default)().subtract(1, 'months').format('YYYYMM');
                this.show = false;
                this.refresh++;
                _context2.next = 15;
                return this.validateForm();

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function resetForm() {
        return _resetForm.apply(this, arguments);
      }

      return resetForm;
    }(),
    validateForm: function validateForm() {
      var _this3 = this;

      this.$refs['ElForm'].validate(function (valid) {
        if (valid) {
          /*
          console.log('-------------------------------------')
          console.log('secteursact', this.secteursact)
          console.log('clients', this.clients)
          console.log('enseignes', this.enseignes)
          console.log('secteursgeo', this.secteursgeo)
          console.log('conducteur', this.conducteur)
          console.log('classement, this.classement)
          console.log('date', this.formData.date)
          */
          _this3.show = false;

          _this3.$loader(true);

          var data = {
            secteursact: _this3.secteursact,
            clients: _this3.clients,
            enseignes: _this3.enseignes,
            secteursgeo: _this3.secteursgeo,
            conducteur: _this3.conducteur ? _this3.conducteur.id : null,
            classement: _this3.classement,
            date: _this3.currentDate,
            id_societe: _this3.user.id_societe
          };
          apiAffaire.rptSynthese(data).then(function (results) {
            _this3.rptData = results;
            _this3.show = true;
          }).then(function () {
            // sauvegarde les filtres dans le localStorage
            _this3.updateFormData({
              pageKey: "".concat(_this3.user.id_societe, "-").concat(_this3.$route.name),
              data: data
            });
          }).finally(function () {
            _this3.refresh++;

            _this3.$loader(false);
          });
        }
      });
    },
    getSummaries: function getSummaries(_ref2) {
      var _this4 = this;

      var columns = _ref2.columns,
          data = _ref2.data;
      var totals = [];
      columns.forEach(function (column, index) {
        if (index === 0 || index === 1) {
          totals[index] = '';
          return;
        }

        if (index === 2) {
          totals[index] = 'TOTAL GENERAL'; // Titre pour la colonne des totaux

          return;
        }

        var columnKey = column.property;

        if (columnKey) {
          // Vérifiez si la colonne est un pourcentage défini dans la configuration
          if (_this4.percentageColumns && _this4.percentageColumns[columnKey]) {
            var _this4$percentageColu = _this4.percentageColumns[columnKey],
                numerator = _this4$percentageColu.numerator,
                denominator = _this4$percentageColu.denominator; // Récupère le numérateur et le dénominateur

            var numeratorTotal = data.reduce(function (sum, row) {
              return sum + (Number(row[numerator]) || 0);
            }, 0);
            var denominatorTotal = data.reduce(function (sum, row) {
              return sum + (Number(row[denominator]) || 0);
            }, 0); // Évitez la division par zéro

            var percentage = denominatorTotal === 0 ? 0 : numeratorTotal / denominatorTotal;
            totals[index] = _vue.default.filter('toPercentage')(percentage); // Appliquez le filtre de pourcentage
          } else {
            // Calcul standard pour les colonnes non pourcentage
            var sum = data.reduce(function (sum, row) {
              var value = Number(row[columnKey]) || 0;
              return sum + value;
            }, 0);
            totals[index] = _vue.default.filter('toCurrency')(sum); // Appliquez le filtre de devise
          }
        } else {
          totals[index] = ''; // Colonne sans clé, aucun total
        }
      });
      return totals;
    },
    // ==================
    // Export excel
    // ==================
    generateExcelFile: function () {
      var _generateExcelFile = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var workbook, title, style, worksheet, columnHeaderList, cellStart, cellEnd, rowCount, buffer, now, fileType, fileName, fileExtension, file, blob;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Classeur Excel
                workbook = new Excel.Workbook();
                title = 'Synthèse de Gestion'; // Style et formatage génériques

                style = {
                  // en-tête
                  header: {
                    font: {
                      bold: true,
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFa4c8ff'
                      }
                    },
                    alignment: {
                      vertical: 'center',
                      horizontal: 'center'
                    },
                    border: {
                      top: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      left: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      bottom: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      right: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      }
                    }
                  },
                  // ligne des totaux
                  totaux: {
                    font: {
                      bold: true,
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFf5f7fa'
                      }
                    },
                    alignment: {
                      vertical: 'center',
                      horizontal: 'right'
                    },
                    border: {
                      top: {
                        style: 'thin',
                        color: {
                          argb: 'FF000000'
                        }
                      },
                      left: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      bottom: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      right: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      }
                    }
                  },
                  // lignes impaires
                  odd: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFDDDDDD'
                      }
                    }
                  },
                  // lignes paires
                  even: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    }
                  }
                }; // Propriétés du classeur

                workbook.creator = 'Groupe MARRAUD - EASY';
                workbook.lastModifiedBy = 'Groupe MARRAUD - EASY'; // workbook.lastPrinted = ''

                workbook.created = new Date();
                workbook.company = 'Groupe MARRAUD';
                workbook.manager = '';
                workbook.title = "Export ".concat(title);
                workbook.subject = '';
                workbook.keywords = this.manager;
                workbook.category = '';
                workbook.description = "Rapport : ".concat(title); // Forcer les calculs au chargement du classeur

                workbook.calcProperties.fullCalcOnLoad = true; // Feuille de calcul avec en-tête et pied de page

                worksheet = workbook.addWorksheet(title, {
                  properties: {
                    defaultRowHeight: 15
                  },
                  headerFooter: {
                    firstHeader: 'Groupe MARRAUD - EASYs - &A',
                    firstFooter: '&L&D à &T&C&F&RPage &P sur &N'
                  },
                  views: [// Viger les volets apres la 2ieme ligne
                  {
                    state: 'frozen',
                    xSplit: 0,
                    ySplit: 2
                  }]
                }); // Add column headers and define column keys and widths
                // Note: these column structures are a workbook-building convenience only,
                // apart from the column width, they will not be fully persisted.
                // Recherche des entetes colonnes d'en-tête

                columnHeaderList = this.getColumnHeaderList(); // Ajout des entetes de colonnes sur la 1ere lignes (colonnes fusionnées)

                cellStart = 0;
                cellEnd = 0; // cellules fusionnées "Données générales affaire"

                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'general');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'general');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Données générales affaire';
                } // cellules fusionnées "Données affaire"


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'donnees_affaire');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'donnees_affaire');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Données affaire';
                } // cellules fusionnées "Consommé N-1"


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'consomme_ym1');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'consomme_ym1');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Gestion N-1';
                } // cellules fusionnées "Gestion Mensuelle N"


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'gest_mens_n');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'gest_mens_n');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Gestion M Mensuelle';
                } // cellules fusionnées "Cumulée N"


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'solde_n');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'solde_n');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Gestion M Cumulée N';
                } // cellules fusionnées "Cumulée totale"


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'gest_cumulee_n');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'gest_cumulee_n');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Gestion M Cumulée totale';
                } // cellules fusionnées "Solde à produire"


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'solde_aproduire');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'solde_aproduire');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Solde à produire';
                } // ajout des entetes de colonnes sur la 2ieme lignes


                worksheet.getRow(2).values = columnHeaderList.map(function (x) {
                  return x.header;
                }); // Définition des colonnes d'en-tête

                worksheet.columns = columnHeaderList.map(function (x) {
                  return {
                    key: x.key,
                    width: x.width
                  };
                }); // Ajout filtres automatiques sur la 2ieme lignes, colonne 1 et 2

                worksheet.autoFilter = 'A2:B2'; // Données

                worksheet.addRows(this.getPreparedDataForExport()); // Totaux sur la derniere ligne

                rowCount = worksheet.rowCount + 1; // code affaire

                worksheet.getCell("A".concat(rowCount)).style = _objectSpread({}, style.totaux); // nom affaire

                worksheet.getCell("B".concat(rowCount)).style = _objectSpread({}, style.totaux); // client

                worksheet.getCell("C".concat(rowCount)).style = _objectSpread({}, style.totaux); // CA initial HT

                worksheet.getCell("D".concat(rowCount)).value = {
                  formula: "SUM(D3:D".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("D".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // MB Etude

                worksheet.getCell("E".concat(rowCount)).value = {
                  formula: "SUM(E3:E".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("E".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // % Etude

                worksheet.getCell("F".concat(rowCount)).value = {
                  formula: "IF(D".concat(rowCount, "=0,0,E").concat(rowCount, "/D").concat(rowCount, ")"),
                  date1904: false
                };
                worksheet.getCell("F".concat(rowCount)).style = _objectSpread({
                  numFmt: '##0.00 %'
                }, style.totaux); // CA Fdc HT

                worksheet.getCell("G".concat(rowCount)).value = {
                  formula: "SUM(G3:G".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("G".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // MB Exé

                worksheet.getCell("H".concat(rowCount)).value = {
                  formula: "SUM(H3:H".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("H".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // % MB

                worksheet.getCell("I".concat(rowCount)).value = {
                  formula: "IF(G".concat(rowCount, "=0,0,H").concat(rowCount, "/G").concat(rowCount, ")"),
                  date1904: false
                };
                worksheet.getCell("I".concat(rowCount)).style = _objectSpread({
                  numFmt: '##0.00 %'
                }, style.totaux); // % Avancement global

                worksheet.getCell("J".concat(rowCount)).style = _objectSpread({}, style.totaux); // Engagés

                worksheet.getCell("K".concat(rowCount)).value = {
                  formula: "SUM(K3:K".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("K".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Gestion N-1: PM

                worksheet.getCell("L".concat(rowCount)).value = {
                  formula: "SUM(L3:L".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("L".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Gestion N-1: MB

                worksheet.getCell("M".concat(rowCount)).value = {
                  formula: "SUM(L3:L".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("M".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Gestion N-1: % MB

                worksheet.getCell("N".concat(rowCount)).value = {
                  formula: "IF(L".concat(rowCount, "=0,0,M").concat(rowCount, "/L").concat(rowCount, ")"),
                  date1904: false
                };
                worksheet.getCell("N".concat(rowCount)).style = _objectSpread({
                  numFmt: '##0.00 %'
                }, style.totaux); // Mensuelle: PM

                worksheet.getCell("O".concat(rowCount)).value = {
                  formula: "SUM(O3:O".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("O".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Mensuelle: MB

                worksheet.getCell("P".concat(rowCount)).value = {
                  formula: "SUM(P3:P".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("P".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Mensuelle: % MB

                worksheet.getCell("Q".concat(rowCount)).value = {
                  formula: "IF(O".concat(rowCount, "=0,0,P").concat(rowCount, "/O").concat(rowCount, ")"),
                  date1904: false
                };
                worksheet.getCell("Q".concat(rowCount)).style = _objectSpread({
                  numFmt: '##0.00 %'
                }, style.totaux); // Cumulée N: PM

                worksheet.getCell("R".concat(rowCount)).value = {
                  formula: "SUM(R3:R".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("R".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Cumulée N: MB

                worksheet.getCell("S".concat(rowCount)).value = {
                  formula: "SUM(S3:S".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("S".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Cumulée N: % MB

                worksheet.getCell("T".concat(rowCount)).value = {
                  formula: "IF(R".concat(rowCount, "=0,0,S").concat(rowCount, "/R").concat(rowCount, ")"),
                  date1904: false
                };
                worksheet.getCell("T".concat(rowCount)).style = _objectSpread({
                  numFmt: '##0.00 %'
                }, style.totaux); // Cumulée totale: PM

                worksheet.getCell("U".concat(rowCount)).value = {
                  formula: "SUM(U3:U".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("U".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Cumulée totale: MB

                worksheet.getCell("V".concat(rowCount)).value = {
                  formula: "SUM(V3:V".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("V".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Cumulée totale: % MB

                worksheet.getCell("W".concat(rowCount)).value = {
                  formula: "IF(U".concat(rowCount, "=0,0,V").concat(rowCount, "/U").concat(rowCount, ")"),
                  date1904: false
                };
                worksheet.getCell("W".concat(rowCount)).style = _objectSpread({
                  numFmt: '##0.00 %'
                }, style.totaux); // Solde à produire: PM

                worksheet.getCell("X".concat(rowCount)).value = {
                  formula: "SUM(X3:X".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("X".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Solde à produire: MB

                worksheet.getCell("Y".concat(rowCount)).value = {
                  formula: "SUM(Y3:Y".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("Y".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Solde à produire: % MB

                worksheet.getCell("Z".concat(rowCount)).value = {
                  formula: "IF(X".concat(rowCount, "=0,0,Y").concat(rowCount, "/X").concat(rowCount, ")"),
                  date1904: false
                };
                worksheet.getCell("Z".concat(rowCount)).style = _objectSpread({
                  numFmt: '##0.00 %'
                }, style.totaux); // Boucle sur les lignes de la feuille du classeur

                worksheet.eachRow(function (row, rowNumber) {
                  // Boucle sur les cellules de la ligne
                  row.eachCell({
                    includeEmpty: true
                  }, function (cell, colNumber) {
                    switch (rowNumber) {
                      // Lignes d'en-tête
                      case 1: // ligne 1

                      case 2:
                        // ligne 2
                        cell.style = _objectSpread({}, style.header);
                        break;
                      // Données

                      default:
                        var columnStyle = columnHeaderList[colNumber - 1].style || {};
                        var cellStyle = {}; // Lignes paires

                        if (rowNumber % 2 === 0) {
                          cellStyle = _objectSpread({}, style.even);
                        } else {
                          cellStyle = _objectSpread({}, style.odd);
                        }

                        cell.style = Object.assign({}, cell.style, columnStyle, cellStyle);
                        break;
                    }
                  });
                }); // Ecriture dans un nouveau buffer

                _context3.next = 95;
                return workbook.xlsx.writeBuffer();

              case 95:
                buffer = _context3.sent;
                // Paramètres du fichier généré dynamiquement
                now = (0, _utils.getDateNow)().format('YYYYMMDD-HHmmss'); // const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'

                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                fileName = 'Rapport-Synthese-de-Gestion';
                fileExtension = 'xlsx';
                file = "".concat(now, "-").concat(fileName, ".").concat(fileExtension); // Création du Blob

                blob = new Blob([buffer], {
                  type: fileType
                }); // Servir le fichier via le navigateur client

                (0, _fileSaver.saveAs)(blob, file);

              case 103:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function generateExcelFile() {
        return _generateExcelFile.apply(this, arguments);
      }

      return generateExcelFile;
    }(),
    getColumnHeaderList: function getColumnHeaderList() {
      var defaultStyles = {
        texte: {
          alignment: {
            vertical: 'top'
          }
        },
        monetaire: {
          numFmt: '# ### ##0.00 "€"',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        pourcentage: {
          numFmt: '##0.00 %',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        date: {
          numFmt: 'dd/mm/yyyy',
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        },
        nombre: {
          numFmt: '0',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        }
      }; // Colonnes d'en-tête

      var columnHeaderList = [// Affaire
      {
        header: 'Code Affaire',
        key: 'num_affaire',
        width: 30,
        style: defaultStyles.texte
      }, {
        header: 'Nom affaire',
        key: 'nom',
        width: 30,
        style: defaultStyles.texte
      }, {
        header: 'Client',
        key: 'client',
        width: 30,
        style: defaultStyles.texte
      }, {
        header: 'CA initial HT',
        group: 'general',
        key: 'ca_initial_ht',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'MB étude',
        group: 'general',
        key: 'mb_etude',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: '% MB',
        group: 'general',
        key: 'pc_mb',
        width: 15,
        style: defaultStyles.pourcentage
      }, {
        header: 'CA Fdc HT',
        group: 'general',
        key: 'ca_fdc_ht',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'MB Exé',
        group: 'general',
        key: 'mb_exe',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: '% MB',
        group: 'general',
        key: 'pc_mb_exe',
        width: 15,
        style: defaultStyles.pourcentage
      }, {
        header: '% Avancement global',
        group: 'donnees_affaire',
        key: 'pc_avancement_cumule',
        width: 15,
        style: defaultStyles.pourcentage
      }, {
        header: 'Engagés',
        group: 'donnees_affaire',
        key: 'mt_engages',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'PM',
        group: 'consomme_ym1',
        key: 'pm_ym1',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'MB',
        group: 'consomme_ym1',
        key: 'mb_ym1',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: '% MB',
        group: 'consomme_ym1',
        key: 'pc_mb_ym1',
        width: 15,
        style: defaultStyles.pourcentage
      }, {
        header: 'PM',
        group: 'gest_mens_n',
        key: 'pm_mensuel',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'MB',
        group: 'gest_mens_n',
        key: 'mb_mensuel',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: '% MB',
        group: 'gest_mens_n',
        key: 'pc_mensuel',
        width: 15,
        style: defaultStyles.pourcentage
      }, {
        header: 'PM',
        group: 'solde_n',
        key: 'pm_solde_n',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'MB',
        group: 'solde_n',
        key: 'mb_solde_n',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: '% MB',
        group: 'solde_n',
        key: 'pc_solde_n',
        width: 15,
        style: defaultStyles.pourcentage
      }, {
        header: 'PM',
        group: 'gest_cumulee_n',
        key: 'pm_cumule',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'MB',
        group: 'gest_cumulee_n',
        key: 'mb_cumule',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: '% MB',
        group: 'gest_cumulee_n',
        key: 'pc_cumule',
        width: 15,
        style: defaultStyles.pourcentage
      }, {
        header: 'PM',
        group: 'solde_aproduire',
        key: 'pm_solde_aproduire',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'MB',
        group: 'solde_aproduire',
        key: 'mb_solde_aproduire',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: '% MB',
        group: 'solde_aproduire',
        key: 'pc_solde_aproduire',
        width: 15,
        style: defaultStyles.pourcentage
      }];
      var columnName = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      columnHeaderList.forEach(function (x, index) {
        x.c = columnName[index];
        x.position = index + 1;
      });
      return columnHeaderList;
    },
    getFirstColumnHeaderByGroup: function getFirstColumnHeaderByGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cells = data.filter(function (x) {
        return x.group === groupName;
      });

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position < accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getLastColumnHeaderByGroup: function getLastColumnHeaderByGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cells = data.filter(function (x) {
        return x.group === groupName;
      });

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position > accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getPreparedDataForExport: function getPreparedDataForExport() {
      // On utilise les données pré-filtrées par le dataTable
      var data = this.rptData;
      data.forEach(function (row) {
        row.ca_initial_ht = parseFloat(row.mtCAinitialHT);
        row.mb_etude = parseFloat(row.mtMB_Etude);
        row.pc_mb = parseFloat(row.pcMB_Etude);
        row.ca_fdc_ht = parseFloat(row.mtCaFdcHT);
        row.mb_exe = row.last_anneemois ? parseFloat(row.mtMB_Exe) : '';
        row.pc_mb_exe = row.last_anneemois ? parseFloat(row.pcMB_Exe) : '';
        row.pc_avancement_cumule = row.last_anneemois ? parseFloat(row.pcAvancementGlobal) : '';
        row.mt_engages = row.last_anneemois ? parseFloat(row.mtEngages) : '';
        row.pm_ym1 = row.last_anneemois ? parseFloat(row.mtPM_ConsommeNmoins1) : '';
        row.mb_ym1 = row.last_anneemois ? parseFloat(row.mtMB_ConsommeNmoins1) : '';
        row.pc_mb_ym1 = row.last_anneemois ? parseFloat(row.pcMB_ConsommeNmoins1) : '';
        row.pm_mensuel = row.last_anneemois ? parseFloat(row.mtPM_M) : '';
        row.mb_mensuel = row.last_anneemois ? parseFloat(row.mtMB_M) : '';
        row.pc_mensuel = row.last_anneemois ? parseFloat(row.pcMB_M) : '';
        row.pm_solde_n = row.last_anneemois ? parseFloat(row.mtPM_CumulN) : '';
        row.mb_solde_n = row.last_anneemois ? parseFloat(row.mtMB_CumulN) : '';
        row.pc_solde_n = row.last_anneemois ? parseFloat(row.pcMB_CumulN) : '';
        row.pm_cumule = row.last_anneemois ? parseFloat(row.mtPM_CumuleTotal) : '';
        row.mb_cumule = row.last_anneemois ? parseFloat(row.mtMB_CumuleTotal) : '';
        row.pc_cumule = row.last_anneemois ? parseFloat(row.pcMB_CumuleTotal) : '';
        row.pm_solde_aproduire = row.last_anneemois ? parseFloat(row.mtSoldeAProduire_PM) : '';
        row.mb_solde_aproduire = row.last_anneemois ? parseFloat(row.mtSoldeAProduire_MB) : '';
        row.pc_solde_aproduire = row.last_anneemois ? parseFloat(row.pcSoldeAProduire_MB) : '';
      });
      return data;
    }
  })
};
exports.default = _default;